import {Link} from 'react-router-dom'


import './breadcrumb.style.css'

const BreadCrumb = ({paths}) => {
    return (
        <>
            {
            <div className="catalogue-breadcrumbs-wrapper breadcrumb">
                {
                paths?.map((elem, index, all) => {
                    const sep=(index+1===all.length)?'':'/';
                    if (elem.Url)
                        return (
                            <span key={index}>
                            <a href={elem.Url} key={index}>{elem.Name}</a> 
                            <span key={2*index+1} className="breadcrumb-sep">{sep}</span> 
                            </span>
                        )
                    else
                        return (
                            <span key={index}>
                            <strong key={index}>{elem.Name}</strong> 
                            <span key={2*index+1} className="breadcrumb-sep">{sep}</span>
                            </span>
                        )
                })
            }
            </div>
            }
        </>
    )
}


export default BreadCrumb